import { Pin } from 'lucide-react'
import { twMerge } from 'tailwind-merge'
import { Button, Tooltip } from '@highlight/ui'
import { ACTIVE_TOOLBAR_BUTTON_CLASS } from './toolbar-button-class'

interface ChromePinButtonProps {
  pressed: boolean
  tooltip: string
  onClick: () => void
  className?: string
}

/** Shared pin glyph for the overlay lock and the popout always-on-top toggle. */
export function ChromePinButton({ pressed, tooltip, onClick, className }: ChromePinButtonProps) {
  return (
    <Tooltip>
      <Tooltip.Trigger
        render={
          <Button
            variant="ghost"
            shape="square"
            onClick={onClick}
            aria-label={tooltip}
            aria-pressed={pressed}
            className={twMerge(pressed && ACTIVE_TOOLBAR_BUTTON_CLASS, className)}
          >
            <Pin aria-hidden="true" className={twMerge(!pressed && 'text-foreground-secondary')} />
          </Button>
        }
      />
      <Tooltip.Content side="bottom">{tooltip}</Tooltip.Content>
    </Tooltip>
  )
}
